
import React, { useEffect, useState } from "react";
import API from '../Services/Location'
import APIS from '../Services/Auth'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
const CenterList = () => {
    const [name, setName] = useState("")
    const [phoneNo, setPhoneNo] = useState("")
    const [email, setEmail] = useState("")
    const [gstNo, setGstNo] = useState("")
    const [webSite, setWebSite] = useState("")
    const [address, setAddress] = useState("")
    const [logo, setLogo] = useState("")
    const [pincode, setPincode] = useState("")
    const [state, setState] = useState("");
    const [city, setCity] = useState("");
    const [errors, setErrors] = useState({});
    const [countryId, setCountryId] = useState(1)
    const [logoPreview, setLogoPreview] = useState(null);
    const [location, setLocation] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const perPage = 10;
    const [id, setId] = useState([])
    const [isEditing, setIsEditing] = useState(false);
    // const [highlight, setHighlight] = useState(false);
    const [search, setSearch] = useState("")
    // const [isClone, setIsClone] = useState("")
    const [getLogo, setGetLogo] = useState("")
    const [getStatus, setStatus] = useState("")
    const [getcreatedAt, setCreatedAt] = useState("")
    const [latitude, setLatitude] = useState("")
    const [longitude, setLongitude] = useState("")
    const [availableRoom, setAvailableRoom] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [chiChiImage, setChiChiImage] = useState(null);
    const [chiChiPreview, setChiChiPreview] = useState(null);
    const [fssaiNumber, setFssaiNumber] = useState("");
    useEffect(() => {
        getLocationList()
    }, [currentPage])

    const getCityData = async (pincode) => {
        try {
            const response = await APIS.getCity(pincode);
            const postData = response?.data?.data;
            if (postData) {
                setCity(postData?.city_name || "");
                setState(postData?.state_name || "");
            } else {
                console.log("No city or state data found in the response.");
                toast.warning('No city or state data found in the response');
            }
        } catch (error) {
            console.error("Error fetching city data:", error.message || error);
        }
    };

    const validateFields = () => {
        // console.log('availableRoom', availableRoom);
        const errors = {};

        const isValidEmail = (email) =>
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);

        const isValidWebsite = (webSite) =>
            /^(https?:\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(:\d{1,5})?(\/.*)?$/.test(webSite);

        const isValidNumber = (value) =>
            /^-?\d+(\.\d+)?$/.test(value);

        const isValidRoom = (value) => /^\d+$/.test(value);

        if (!name) {
            errors.name = "Name is required";
        } else if (!/^[A-Za-z\s]+$/.test(name)) {
            errors.name = "Name can only contain letters and spaces";
        }

        if (!address) {
            errors.address = "Address is required";
        }

        if (!pincode || pincode?.toString()?.length !== 6) {
            errors.pincode = "Invalid PinCode";
        }

        if (!(phoneNo?.trim())) {
            errors.phoneNo = "Mobile number is required";
        } else if (!/^\d{10}$/.test(phoneNo)) {
            errors.phoneNo = "Mobile number must be 10 digits";
        }

        if (email?.trim() && !isValidEmail(email)) {
            errors.email = "Invalid email format";
        }

        if (webSite?.trim() && !isValidWebsite(webSite)) {
            errors.webSite = "Invalid website format";
        }

        if (!gstNo) {
            errors.gstNo = "GST Number is required";
        } else if (!/^[0-9]{2}[A-Z a-z]{5}[0-9]{4}[A-Z a-z]{1}[0-9A-Z a-z]{3}$/.test(gstNo)) {
            errors.gstNo = "GST Number must be exactly 15 characters (alphanumeric)";
        }

        if (latitude?.trim() && !isValidNumber(latitude)) {
            errors.latitude = "Latitude must be a valid number";
        }

        if (longitude?.trim() && !isValidNumber(longitude)) {
            errors.longitude = "Longitude must be a valid number";
        }
        if (availableRoom === null || availableRoom === undefined || availableRoom === '') {
            errors.availableRoom = "If party rooms are not available on respective center then add 0";
        } else if (!isValidRoom(availableRoom.toString())) {
            errors.availableRoom = "Party rooms must be a valid number";
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }
        switch (fieldName) {
            case "name":
                setName(value);
                break;
            case "address":
                setAddress(value);
                break;
            case "pincode":
                setPincode(value);

                if (value.length < 6) {
                    setCity("");
                    setState("");
                    return;
                }
                if (value.length === 6) {
                    getCityData(value);
                }
                break;
            case "countryId":
                setCountryId(value);
                break;
            case "phoneNo":
                setPhoneNo(value);
                break;
            case "webSite":
                setWebSite(value);
                break;
            case "gstNo":
                setGstNo(value);
                break;
            case "email":
                setEmail(value);
                break;
            case "logo":
                setLogo(value);
                break;
            case "latitude":
                setLatitude(value);
                break;
            case "longitude":
                setLongitude(value);
                break;
            case "availableRoom":
                setAvailableRoom(value);
                break;
            case "fssaiNumber":
                setFssaiNumber(value);
                break;
            default:
                break;
        }
    };

    const handleLogoChange = (event, type) => {
        const file = event.target.files[0];

        if (!file) return;

        const allowedFormats = ['image/jpeg', 'image/png', 'image/gif'];
        const maxSize = 5 * 1024 * 1024;

        if (!allowedFormats.includes(file.type)) {
            toast.error("Only JPG, PNG and GIF formats are allowed.");
            event.target.value = '';
            return;
        }

        if (file.size > maxSize) {
            toast.error("File size must be 5MB or smaller.");
            event.target.value = '';
            return;
        }

        // 🔥 Type based handling
        if (type === "logo") {
            setLogo(file);
            setLogoPreview(URL.createObjectURL(file));
        }

        if (type === "chichi") {
            setChiChiImage(file);
            setChiChiPreview(URL.createObjectURL(file));
        }
    };
    const getLocationList = async () => {
        try {
            const payload = {
                limit: perPage,
                pageNumber: currentPage,
                search: search,
                is_active: selectedStatus
            };
            const response = await API.getLocationList(payload);
            setLocation(response?.data?.data);
            setTotalRecords(response?.data?.totalCount);
        } catch (error) {
            if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.error("Error fetching location list:", error);
        }
    };


    const totalPages = Math.ceil(totalRecords / perPage);
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
            // getLocationList();
        }
    };
    const getPageNumbers = () => {
        const maxVisible = 10;
        const pageNumbers = [];
        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            const left = Math.max(1, currentPage - 3);
            const right = Math.min(totalPages, currentPage + 3);
            if (left > 2) {
                pageNumbers.push(1, '...');
            } else {
                for (let i = 1; i < left; i++) {
                    pageNumbers.push(i);
                }
            }
            for (let i = left; i <= right; i++) {
                pageNumbers.push(i);
            }
            if (right < totalPages - 1) {
                pageNumbers.push('...', totalPages);
            } else {
                for (let i = right + 1; i <= totalPages; i++) {
                    pageNumbers.push(i);
                }
            }
        }
        return pageNumbers;
    };

    const handleStatusToggle = async (id, currentStatus) => {
        const updatedStatus = !currentStatus;
        try {
            const response = await API.changeLocationList(id, updatedStatus);
            if (response.status === 200) {
                setLocation((prevLocation) =>
                    prevLocation.map((item) =>
                        item.id === id ? { ...item, is_active: updatedStatus } : item
                    )
                );
                toast.success(
                    `Location ${updatedStatus ? "Activated" : "De-Activated"} successfully!`
                );
            } else {
                console.log("Error updating status:", response);
                toast.error("Failed to update the status. Please try again.");
            }
        } catch (error) {
            if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.log("Error in status toggle:", error);
            toast.error("Failed to update the status. Please try again.");
        }
    };


    const handleGetData = async (locationId) => {
        const payload = {
            //pageNumber: currentPage,
            limit: 0,
            id: locationId
        }
        try {
            const response = await API.getLocationList(payload);
            const fetchedData = response?.data?.data[0];
            //console.log("fetchdata...", fetchedData)
            if (fetchedData) {
                // setHighlight(true);
                setId(fetchedData.id);
                setName(fetchedData?.name)
                setAddress(fetchedData?.address)
                setPincode(fetchedData?.pincode)
                setState(fetchedData?.state_name)
                setCity(fetchedData?.city_name)
                setCountryId(fetchedData?.country_id)
                setPhoneNo(fetchedData?.phone_no)
                setWebSite(fetchedData?.website)
                setGstNo(fetchedData?.gst_no)
                setEmail(fetchedData?.email)
                // setLogo(fetchedData?.logo)
                setLogoPreview(fetchedData?.logo)
                setChiChiPreview(fetchedData?.brand_image)
                setStatus(fetchedData?.is_active);
                setCreatedAt(fetchedData?.createdAt);
                setLatitude(fetchedData?.latitude);
                setLongitude(fetchedData?.longitude);
                setIsEditing(true);
                setAvailableRoom(fetchedData?.available_room)
                setFssaiNumber(fetchedData?.fassi_no)

            } else {
                toast.error("Failed to location details.");
            }
        } catch (error) {
            if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.error("Error fetching data:", error);
        }
    };
    const handleGetLogo = (logo) => {
        setGetLogo(logo);
    }


    const updateLocationData = async () => {
        if (!validateFields()) return;
        try {
            const formData = new FormData();
            formData.append("name", name);
            formData.append("phone_no", phoneNo);
            formData.append("email", email);
            formData.append("gst_no", gstNo);
            formData.append("website", webSite);
            formData.append("address", address);
            formData.append("pincode", pincode);
            formData.append("company_id", "1");
            formData.append("country_id", countryId);
            formData.append("latitude", latitude);
            formData.append("longitude", longitude);
            formData.append('available_room', availableRoom);
            formData.append('fassi_no', fssaiNumber)

            let updatedLogo = logo || logoPreview;
            if (updatedLogo && typeof updatedLogo === "object" && updatedLogo instanceof Blob) {
                formData.append("logo", updatedLogo);
            } else {

            }
            if (chiChiImage && chiChiImage instanceof Blob) {
                formData.append("brand_image", chiChiImage);
            }

            // Debugging FormData
            for (let pair of formData.entries()) {
                console.log(`${pair[0]}: ${pair[1]}`);
            }
            const response = await API.updateLocationData(id, formData);
            if (response?.status === 200) {
                toast.success(response?.data?.message);
                setTimeout(() => window.location.reload(), 2000);
                getLocationList();
            } else {
                toast.error(response?.data?.message || "Failed to update location. Please try again.");
            }
        } catch (error) {
            console.error("Error updating location:", error);

            if (error?.response?.status === 403) {
                window.location.replace("/Login");
            }
            else {
                toast.error(error?.response?.data?.message || "An error occurred. Please try again.");
            }
        }
    };

    const handleSubmit = async () => {
        if (!validateFields()) return;
        if (isEditing) {
            await updateLocationData();
        }

    };
    const handleCancel = () => {
        setTimeout(() => window.location.reload());
        setName("")
        setCity("")
        setPhoneNo("")
        setAddress("")
        setEmail("")
        setGstNo("")
        setCountryId("")
        setWebSite("")
        setLogo("")
        setPincode("")
        // setIsClone("")
        setLatitude("")
        setLongitude("")
    }


    const handleFieldChange1 = (e, fieldName) => {
        const value = e.target.value;
        if (fieldName === "search") {
            setSearch(value);
            if (value.trim() === "") {
                setCurrentPage(1);
                getLocationList(1);
            }
        }
    };


    const handleSearch = () => {
        if (search.trim() === "") {
            setCurrentPage(1);
            getLocationList(1);
        } else {
            setCurrentPage(1);
            getLocationList(1);
        }
    };


    return (
        <div>
            <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">Center List</h4>
                    </div>
                    <div className="card-body">
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label htmlFor="ddSalesType" className="form-label">
                                    <b>Search by Center Name</b></label>
                                <input type="text" className="form-control" placeholder="Search by Center Name"
                                    value={search}
                                    onChange={(e) => handleFieldChange1(e, "search")}
                                />
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label htmlFor="ddSalesType" className="form-label">
                                        <b>Status</b>
                                    </label>
                                    <select
                                        className="form-select"
                                        id="ddSalesType"
                                        value={selectedStatus}
                                        onChange={(e) => setSelectedStatus(e.target.value)}>
                                        <option value="">Select</option>
                                        <option value="1">Active</option>
                                        <option value="0">Inactive</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-2"> <label htmlFor="ddSalesType" className="form-label">

                            </label>
                                <button onClick={handleSearch} className="btn btn-success" type="button">Search</button>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-bordered text-center">
                                <thead>
                                    <tr>
                                        <th>SrNo</th>
                                        <th>Action</th>
                                        <th>Name</th>
                                        <th>Center ID</th>
                                        <th>GST No</th>
                                        <th>Pincode</th>
                                        <th>State</th>
                                        <th>City</th>
                                        <th>Address</th>
                                        <th>Phone Number</th>
                                        <th>Available Party Room</th>
                                        <th>Latitude</th>
                                        <th>Longitude</th>
                                        <th>Email</th>
                                        <th>Status</th>
                                        <th>Created Date</th>
                                        <th>Logo</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {location.map((item, index) => (

                                        <tr key={item.id} data-active={item?.is_active ? "true" : "false"}>
                                            <td>{(currentPage - 1) * perPage + index + 1}</td>
                                            <td>
                                                <div className="navbar-menu-wrapper d-flex align-items-stretch">
                                                    <ul className="navbar-nav navbar-nav-right">
                                                        <li className="nav-item nav-profile1">
                                                            <span className="nav-link dropdown-toggle1" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <div className="nav-profile-text1">
                                                                    <p className="mb-1 text-black">                                                    {/* <span className="mdi mdi-menu" style={{ width: "100px", height: "100px", fontSize: "30px", color: "black" }}></span> */}
                                                                    </p>
                                                                </div>
                                                            </span>
                                                            <span className="nav-link mdi mdi-menu" style={{ width: "100px", fontSize: "30px", color: "black" }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                                                            <div className="dropdown-menu navbar-dropdown text-center" aria-labelledby="actionDropdown">
                                                                <a className="dropdown-item">
                                                                    <button onClick={() => handleGetData(item.id)} className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalLocationView">
                                                                        View
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">
                                                                    <button onClick={() => handleGetData(item.id)}
                                                                        className="btn btn-primary btn-sm" type="button"
                                                                        data-bs-toggle="modal" data-bs-target="#myModalLocationEdit"
                                                                    >
                                                                        Edit
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">
                                                                    {localStorage.getItem("location_id") !== item.id && (
                                                                        <button
                                                                            className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
                                                                            onClick={() => handleStatusToggle(item.id, item.is_active)}
                                                                        >
                                                                            {item.is_active ? "De-Activate" : "Activate"}
                                                                        </button>
                                                                    )}
                                                                </a>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </td>
                                            <td>{item.name}</td>
                                            <td>{item?.id}</td>
                                            <td>{item.gst_no}</td>
                                            <td>{item.pincode}</td>
                                            <td>{item?.state_name}</td>
                                            <td>{item?.city_name}</td>

                                            <td style={{ textAlign: 'left' }}>
                                                {item.address && item.address
                                                    .match(new RegExp(`.{1,50}(\\s|$)`, 'g'))
                                                    .map((line, index) => (
                                                        <div key={index}>{line.trim()}</div>
                                                    ))}

                                            </td>

                                            <td>{item.phone_no}</td>
                                            <td>{item?.available_room}</td>
                                            <td>{item?.latitude}</td>
                                            <td>{item?.longitude}</td>
                                            <td>{item.email}</td>

                                            <td>{item?.is_active ? "Active" : "De-Activated"}</td>
                                            <td>{moment(item?.createdAt).format("DD-MM-YYYY")}</td>
                                            <td>
                                                {/* <button onClick={() => handleGetLogo(item.logo)}
                                                    className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModallogo">
                                                    View
                                                </button> */}
                                                {item.logo && item.logo.trim() !== "" ? (
                                                    <button
                                                        onClick={() => handleGetLogo(item.logo)}
                                                        className="btn btn-success btn-sm"
                                                        type="button"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#myModallogo"
                                                    >
                                                        View
                                                    </button>
                                                ) : "N/A"}

                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination justify-content-center  mt-3">
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            Previous
                                        </button>
                                    </li>

                                    {getPageNumbers().map((page, index) => (
                                        <li
                                            key={index}
                                            className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}>
                                            {page === "..." ? (
                                                <span className="page-link">...</span>
                                            ) : (
                                                <button className="page-link" onClick={() => handlePageChange(page)}>
                                                    {page}
                                                </button>
                                            )}
                                        </li>
                                    ))}
                                    <li
                                        className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}>
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
            <section>
                <div className="modal" id="myModallogo">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Logo</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <div className="row my-3" style={{ justifyContent: "center" }}>
                                    <img src={getLogo} alt="Logo" style={{ "width": "200px", "height": "150px" }} />
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="modal" id="myModalLocationEdit">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="card-body mt-3">
                                <div className="container">
                                    <h4 className="card-title">Update Center</h4>
                                    <div className="forms-sample my-3">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="name">Name <span style={{ color: "red" }}>*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="txtname"
                                                        placeholder="Name"
                                                        value={name}
                                                        onChange={(e) => handleFieldChange(e, "name")}
                                                    />
                                                    {errors.name && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.name}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="Address">Address <span style={{ color: "red" }}>*</span></label>
                                                    <textarea
                                                        type="text"
                                                        className="form-control"
                                                        id="txtaddress"
                                                        placeholder="Address"
                                                        rows={1}
                                                        value={address}
                                                        onChange={(e) => handleFieldChange(e, "address")}
                                                    />
                                                    {errors.address && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.address}</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="PinCode">PinCode <span style={{ color: "red" }}>*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="txtpincode"
                                                        placeholder="Pin Code"
                                                        maxLength={6}
                                                        value={pincode}
                                                        onChange={(e) => handleFieldChange(e, "pincode")}
                                                    />
                                                    {errors.pincode && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.pincode}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="email">City</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="txtcity"
                                                        placeholder={city}
                                                        value={city}
                                                        readOnly
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="state">State</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="txtstate"
                                                        placeholder={state}
                                                        value={state}
                                                        readOnly
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="Country">Country</label>
                                                    <select className="form-select" id="ddlCountry" value={countryId}
                                                        onChange={(e) => handleFieldChange(e, "countryId")} >
                                                        <option value={1}>India</option>
                                                    </select>
                                                    {errors.countryId && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.countryId}</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="phone">Phone Number <span style={{ color: "red" }}>*</span></label>
                                                    <input
                                                        type="text"
                                                        maxLength={10}
                                                        className="form-control"
                                                        id="txtmobile"
                                                        placeholder="Phone Number"
                                                        value={phoneNo}
                                                        onChange={(e) => handleFieldChange(e, "phoneNo")}
                                                    />
                                                    {errors.phoneNo && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.phoneNo}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="Website">Website</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="txtWebsite"
                                                        placeholder="Website"
                                                        value={webSite}
                                                        onChange={(e) => handleFieldChange(e, "webSite")}
                                                    />
                                                    {errors.webSite && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.webSite}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="Website">GST No <span style={{ color: "red" }}>*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="txtgstno"
                                                        placeholder="GST No"
                                                        value={gstNo}
                                                        maxLength={15}
                                                        onChange={(e) => handleFieldChange(e, "gstNo")}
                                                    />
                                                    {errors.gstNo && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.gstNo}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="Email">FSSAI Number</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="txtroom"
                                                        placeholder="FSSAI Number"
                                                        value={fssaiNumber}
                                                        onChange={(e) => handleFieldChange(e, "fssaiNumber")}
                                                    />
                                                    {errors.fssaiNumber && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.fssaiNumber}</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="Email">Email</label>
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        id="txtemail"
                                                        placeholder="Email"
                                                        value={email}
                                                        onChange={(e) => handleFieldChange(e, "email")}
                                                    />
                                                    {errors.email && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.email}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="Email">Latitude</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="txtemail"
                                                        placeholder="Latitude"
                                                        value={latitude}
                                                        maxLength={10}
                                                        onChange={(e) => handleFieldChange(e, "latitude")}
                                                    />
                                                    {errors.latitude && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.latitude}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="Email">Longitude</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="txtemail"
                                                        placeholder="Longitude"
                                                        value={longitude}
                                                        maxLength={10}
                                                        onChange={(e) => handleFieldChange(e, "longitude")}
                                                    />
                                                    {errors.longitude && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.longitude}</span>}
                                                </div>
                                            </div>

                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="Email">Available Party Room</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="txtroom"
                                                        placeholder="Available Room"
                                                        value={availableRoom}
                                                        onChange={(e) => handleFieldChange(e, "availableRoom")}
                                                    />
                                                    {errors.availableRoom && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.availableRoom}</span>}
                                                </div>
                                            </div>


                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="Website">Upload Logo</label>
                                                    <input
                                                        accept="image/png, image/gif, image/jpeg"
                                                        type="file"
                                                        className="form-control"
                                                        id="txtimage"
                                                        // onChange={handleLogoChange}
                                                        onChange={(e) => handleLogoChange(e, "logo")}
                                                    />

                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    {logoPreview && (
                                                        <div className="mt-2">
                                                            <img src={logoPreview} alt="Logo Preview" style={{ width: '100px', height: 'auto' }} />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="Website">Chi-Chi Image</label>
                                                    <input
                                                        accept="image/png, image/gif, image/jpeg"
                                                        type="file"
                                                        className="form-control"
                                                        onChange={(e) => handleLogoChange(e, "chichi")}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    {chiChiPreview && (
                                                        <div className="mt-2">
                                                            <img
                                                                src={chiChiPreview}
                                                                alt="ChiChi Preview"
                                                                style={{ width: '100px', height: 'auto' }}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-3">
                                            {!isEditing && (
                                                <button
                                                    onClick={handleSubmit}
                                                    type="button"
                                                    className="btn btn-primary"
                                                >
                                                    Submit
                                                </button>
                                            )}
                                            {isEditing && (
                                                <button
                                                    onClick={handleSubmit}
                                                    type="button"
                                                    className="btn btn-primary"
                                                >
                                                    Update
                                                </button>
                                            )}
                                            <button onClick={handleCancel} className="btn btn-light ms-2">Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="modal" id="myModalLocationView" data-bs-backdrop="static">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Center List Details</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="col-lg-12 grid-margin stretch-card">
                                    <div className="card">
                                        <div className="card-body text-center">
                                            <div className="table-responsive">
                                                <table className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>Name</th>

                                                            <th>Phone Number</th>
                                                            <th>Address</th>
                                                            <th>State</th>
                                                        </tr>
                                                        <tr>
                                                            <td>{name}</td>
                                                            <td>{phoneNo}</td>

                                                            <td style={{ textAlign: 'left' }}>
                                                                {address && address
                                                                    .match(new RegExp(`.{1,50}(\\s|$)`, 'g'))
                                                                    .map((line, index) => (
                                                                        <div key={index}>{line.trim()}</div>
                                                                    ))}
                                                            </td>

                                                            <td>{state}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>City</th>
                                                            <th>Pincode</th>
                                                            <th>GST No</th>
                                                            <th>Email</th>
                                                        </tr>
                                                        <tr>
                                                            <td>{city}</td>
                                                            <td>{pincode}</td>
                                                            <td>{gstNo}</td>
                                                            <td>{email}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Latitude</th>
                                                            <th>Longitude</th>
                                                            <th>Status</th>
                                                            <th>Created Date</th>
                                                        </tr>
                                                        <tr>
                                                            <td>{latitude}</td>
                                                            <td>{longitude}</td>
                                                            <td>{getStatus ? "Active" : "De-Activated"}</td>
                                                            <td>
                                                                {moment(getcreatedAt).format("DD-MM-YYYY")}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>Website</th>
                                                            <th>Available Party Room</th>
                                                            <th>Logo</th>
                                                            <th>Chi Chi Image</th>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                {webSite}
                                                            </td>
                                                            <td>
                                                                {availableRoom}
                                                            </td>
                                                            <td>
                                                                {logoPreview ? (
                                                                    <img
                                                                        src={logoPreview}
                                                                        alt="Image"
                                                                        width="50"
                                                                        height="50"

                                                                    />
                                                                ) : (
                                                                    <span>No Image Available</span>
                                                                )}

                                                            </td>
                                                            <td>
                                                                {chiChiPreview ? (
                                                                    <img
                                                                        src={chiChiPreview}
                                                                        alt="Image"
                                                                        width="150"
                                                                        height="150"

                                                                    />
                                                                ) : (
                                                                    <span>No Image Available</span>
                                                                )}

                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                FSSAI Numner
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                {fssaiNumber}
                                                            </td>
                                                        </tr>
                                                    </thead>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CenterList;
